export type MapTileConfig = {
  tile_url_template?: string;
  tile_subdomains?: string[] | false | null;
  tile_zoom_offset?: number;
  tile_size?: number;
  attribution?: string;
  provider_code?: string;
  error?: string;
};

export const DEFAULT_TOMTOM_TILE_SUBDOMAINS = ["a", "b", "c", "d"];

export function getLeafletTileLayerOptions(
  config: MapTileConfig
): Record<string, unknown> {
  const tileSize = config.tile_size || 256;
  const options: Record<string, unknown> = {
    attribution: config.attribution || "© OpenStreetMap contributors",
    maxZoom: 22,
    tileSize,
  };

  const template = config.tile_url_template || "";
  if (template.includes("{s}")) {
    options.subdomains =
      Array.isArray(config.tile_subdomains) && config.tile_subdomains.length > 0
        ? config.tile_subdomains
        : DEFAULT_TOMTOM_TILE_SUBDOMAINS;
  }

  if (tileSize === 512) {
    options.zoomOffset = config.tile_zoom_offset ?? -1;
  } else if (config.tile_zoom_offset != null) {
    options.zoomOffset = config.tile_zoom_offset;
  }

  return options;
}

export type ActiveRoutingProviderPayload = {
  active?: boolean;
  driver_location_map_config?: MapTileConfig;
  provider_extra?: {
    tomtom_use_for_driver_location?: boolean;
  };
};

export const OPENSTREETMAP_TILE_CONFIG: MapTileConfig = {
  provider_code: "openstreetmap",
  tile_url_template: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
  attribution: "© OpenStreetMap contributors",
  tile_subdomains: [],
  tile_zoom_offset: 0,
};

export function shouldUseTomTomMapTiles(
  payload: ActiveRoutingProviderPayload | null | undefined
): boolean {
  return payload?.provider_extra?.tomtom_use_for_driver_location === true;
}

/** Dashboard route map tiles: TomTom only when configured, otherwise OSM. */
export function resolveDashboardMapTileConfig(
  payload: ActiveRoutingProviderPayload | null | undefined
): MapTileConfig {
  if (shouldUseTomTomMapTiles(payload)) {
    const tomTomConfig = payload?.driver_location_map_config;
    if (tomTomConfig?.tile_url_template) {
      return tomTomConfig;
    }
  }

  const osmFromBackend = payload?.driver_location_map_config;
  if (
    osmFromBackend?.tile_url_template &&
    osmFromBackend.provider_code === "openstreetmap"
  ) {
    return osmFromBackend;
  }

  return OPENSTREETMAP_TILE_CONFIG;
}
